import { render, staticRenderFns } from "./IDSResourcesPageConsumption.html?vue&type=template&id=0e8f46c0&external"
import script from "./IDSResourcesPageConsumption.js?vue&type=script&lang=js&external"
export * from "./IDSResourcesPageConsumption.js?vue&type=script&lang=js&external"
import style0 from "./IDSResourcesPageConsumption.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports